// extracted by mini-css-extract-plugin
module.exports = {"breads_wrapper":"breads_wrapper___3Q-W8","home_icon_wrapper":"home_icon_wrapper___1zJF5","home_icon":"home_icon___3ShPc","breads_inner":"breads_inner___jiflF"};